import React from "react";
import { User, Target, CalendarClock } from "lucide-react";
import { StatusBadge } from "@/components/ds";
import type { InboxDetail } from "@/lib/api";
import { fmtTime } from "./constants";

function Row({ label, value }: { label: string; value?: React.ReactNode }) {
  return (
    <div className="flex items-start justify-between gap-3 py-1">
      <span className="text-xs text-slate-400">{label}</span>
      <span className="text-right text-xs font-medium text-slate-700">{value ?? "—"}</span>
    </div>
  );
}

export function SidePanels({ detail }: { detail: InboxDetail }) {
  const c = detail.contact as any;
  const l = detail.lead as any;
  const a = detail.appointment as any;
  return (
    <div className="space-y-4" data-testid="inbox-side-panels">
      <div className="rounded-lg border border-slate-200 bg-white p-4" data-testid="panel-contact">
        <div className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-800"><User className="h-4 w-4 text-slate-400" /> Contact</div>
        {c ? (
          <>
            <Row label="Name" value={`${c.first_name} ${c.last_name ?? ""}`.trim()} />
            <Row label="Phone" value={c.phone} />
            <Row label="Email" value={c.email} />
            <Row label="SMS consent" value={c.sms_consent_status} />
            {(c.do_not_call || c.do_not_text) && <div className="mt-1 flex gap-1">{c.do_not_call && <StatusBadge tone="red">DNC</StatusBadge>}{c.do_not_text && <StatusBadge tone="red">DNT</StatusBadge>}</div>}
          </>
        ) : <p className="text-xs text-slate-400">No linked contact.</p>}
      </div>

      <div className="rounded-lg border border-slate-200 bg-white p-4" data-testid="panel-lead">
        <div className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-800"><Target className="h-4 w-4 text-slate-400" /> Lead</div>
        {l ? (
          <>
            <Row label="Service" value={l.requested_service} />
            <Row label="Stage" value={l.stage} />
            <Row label="Priority" value={l.priority} />
            <Row label="Est. value" value={l.estimated_value != null ? `$${Number(l.estimated_value).toLocaleString()}` : "—"} />
          </>
        ) : <p className="text-xs text-slate-400">No linked lead.</p>}
      </div>

      <div className="rounded-lg border border-slate-200 bg-white p-4" data-testid="panel-appointment">
        <div className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-800"><CalendarClock className="h-4 w-4 text-slate-400" /> Appointment</div>
        {a ? (
          <>
            <Row label="Service" value={a.service_name ?? a.requested_service} />
            <Row label="When" value={fmtTime(a.start_at)} />
            <Row label="Status" value={a.status} />
          </>
        ) : <p className="text-xs text-slate-400">No appointment linked.</p>}
      </div>
    </div>
  );
}
